import { PayloadAction } from '@reduxjs/toolkit';
import { DTOworkspacePaymentTransactionStripe } from '@shared/dto/+workspace/workspace_payment_transaction.ts/dto_workspace_payment_transaction_stripe';
import { ENUM__redux_action } from '../../_base/ENUM__redux_action';
import { StateWorkspaceBilling } from './state_workspace_billing';

export const local_workspace_billing_payment_transactions_upsert = (
  payload: DTOworkspacePaymentTransactionStripe[],
): PayloadAction<DTOworkspacePaymentTransactionStripe[]> => ({
  type: ENUM__redux_action.WORKSPACE_BILLING_PAYMENT_TRANSACTIONS_UPSERT,
  payload: payload,
});

export const init_workspace_local_billing_payment_transactions_upsert = (
  state: StateWorkspaceBilling,
  action: PayloadAction<DTOworkspacePaymentTransactionStripe[]>,
) => {
  if (action.payload.is_empty()) return;

  for (let item of action.payload) {
    let workspace_transactions_map = state.payment_transactions_map.get_or_create_map(item.workspace_id);

    workspace_transactions_map.set(item._id, item);
  }

  //need to force a re-render
  state.payment_transactions_map = new Map(state.payment_transactions_map);
};
